import request from "./http";
import qs from 'qs'


//负荷能耗—>通过单位号查询负荷或能耗
// 
export function findLoadPowerByGroupNo(params) {
    return request({
        url: "/loadPower/findLoadPowerByGroupNo",
        method: "get",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
        params
 
    });
}
//负荷能耗->批量增加负荷或能耗
// 
export function loadPowerSaveLoadPower(params) {
    return request({
        url: "/loadPower/saveLoadPower",
        method: "post",
        headers:{
            'Content-Type':'application/x-www-form-urlencoded',
            'Accept':'*/*'
          },
        params
 
    });
}
//负荷能耗>通过id批量删除
// 
export function loadPowerDeleteLoadPower(params) {
    return request({
        url: "/loadPower/deleteLoadPower",
        method: "delete",
        params
 
    });
}
